var render = function render(){var _vm=this,_c=_vm._self._c;return _c('expression-selector',{attrs:{"single-select":true,"crud-actions":false,"selection-mode":true,"batch-select":false,"default-tags":['SEQUENCE'],"data-table-height":400,"card-color":"grey-lighten-5"},on:{"expression-selected":function($event){return _vm.$emit('sequence-selected', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }